import { I18n } from '@components/Trans';
import styled from 'styled-components';

export const DialogTitle = styled(I18n).attrs(() => ({ variant: 'subtitle2' }))`
    && {
        font-size: 16px;
        font-weight: 500;
        color: #222;
    }
`;
